import React, { Component } from "react";

// Redux
import { connect } from "react-redux";
import { getFunderInvestmentPool } from "./../../redux/actions/funders";
import { setToast } from "./../../redux/actions/toast";
import { showModal } from "./../../redux/actions/modal";

// Data Models
import {
  barData,
  doughnutData,
  doughnutData2,
  lineData,
  investmentLineData,
} from "../../models/chart-data-models";

// Custom UI
import Filter from "./Filter/Filter";

// Custom Styles
import "./Subscriptions.css";

class Subscriptions extends Component {
  //State
  state = {
    dataSummary: true,
    chartData: {
      doughnutData,
      doughnutData2,
      barData,
      lineData,
      investmentLineData,
    },
  };

  // Open Modal
  modalHandler = (modalData) => {
    this.props.showModal(modalData);
  };

  componentDidMount = () => {
    this.props.getFunderInvestmentPool();
  };

  render() {
    const { loggedInUser, funderInvestmentPool } = this.props;

    const { first_name, user_type } = loggedInUser;

    return (
      <div className="datatable-wrapper">
        {/*Welcome Block*/}
        <div className="block-header">
          <div className="row mt-10">
            <div className="col-lg-12 col-md-6 col-sm-7 dashboard-title">
              <div className="col-lg-9 col-md-9 col-sm-9 col-xl-9">
                <h3 className="m-l-1 animated speed-1x fadeInRight">
                  <i className="fas fa-user-circle capitalize" /> Hi{" "}
                  {first_name},
                </h3>
                <h5 className="userRole animated speed-1x fadeInRight capitalize">
                  {user_type}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div id="trending" className="table-view animated fadeInRight">
          {/*Welcome Block*/}
          <div className="block-header">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-7 dashboard-title">
                <h3 className="m-l-1">
                  <aside className="rounder">
                    <i className="fas fa-chart-pie" />
                  </aside>
                  &nbsp; Explore Ecosystems
                </h3>
              </div>
            </div>
          </div>

          {/*Top Performance*/}
          <div className="table-view">
            <div className="mt-20">
              <Filter view={this.viewEcosystem} data={funderInvestmentPool} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  fundersReducer: { funderInvestmentPool },
  authReducer: { loggedInUser },
}) => {
  return {
    funderInvestmentPool,
    loggedInUser,
  };
};

export default connect(mapStateToProps, {
  getFunderInvestmentPool,
  setToast,
  showModal,
})(Subscriptions);
